<app-list-module-table
  variant="surface"
  [columns]="columns"
  [rows]="rows"
  [loading]="loading"
  [emptyMessage]="emptyMessage"
  [sortColumn]="sortColumn"
  [sortDirection]="sortDirection"
  (sortChange)="sortChange.emit($event)"
  rowTrackKey="id"
>
  <ng-template listCellDef="role" let-row="row">
    <div class="flex w-max items-center">
      <div
        class="grid h-8 w-8 shrink-0 place-content-center rounded-full bg-primary text-sm font-semibold text-white ltr:mr-2 rtl:ml-2"
      >
        {{ initials(row.role_name) }}
      </div>
      <div class="min-w-0">
        <div class="font-bold text-primary dark:text-white">{{ row.role_name }}</div>
        <div class="text-xs text-gray-500 dark:text-gray-400">{{ row.description || row.slug }}</div>
      </div>
    </div>
  </ng-template>

  <ng-template listCellDef="slug" let-row="row">
    <span class="font-mono text-xs text-blue-600 dark:text-blue-400">{{ row.slug }}</span>
  </ng-template>

  <ng-template listCellDef="date" let-row="row">
    @if (view === 'deleted') {
    {{ row.deleted_at | appDate }}
    } @else {
    {{ row.created_at | appDate }}
    }
  </ng-template>

  <ng-template listCellDef="status" let-row="row">
    <div
      class="inline-flex items-center rounded-full py-1 px-3 text-xs font-bold"
      [ngClass]="statusBadgeClass(row)"
    >
      {{ statusLabel(row) }}
    </div>
  </ng-template>

  <ng-template listCellDef="permissions" let-row="row">
    @if (isProtectedRole(row)) {
    <span class="text-xs text-gray-400 dark:text-gray-500">—</span>
    } @else if (P.ROLE_MANAGE_PERMISSIONS | hasPermission) {
    <button
      type="button"
      (click)="goToManagePermissions(row)"
      class="inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 dark:border-[#191e3a] dark:bg-[#0e1726] dark:text-white-dark dark:hover:bg-white/5"
    >
      <icon-settings class="size-4 shrink-0" />
      Manage Permission
    </button>
    } @else {
    <span class="text-xs text-gray-400 dark:text-gray-500">—</span>
    }
  </ng-template>

  <ng-template listCellDef="actions" let-row="row" let-i="index">
    @if (isProtectedRole(row)) {
    <span class="text-xs text-gray-400 dark:text-gray-500">Protected</span>
    } @else {
    <div class="agent-action-menu relative inline-flex justify-end">
      <button
        type="button"
        class="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-white/10"
        (click)="toggleMenu.emit({ key: actionMenuRowKey(i), event: $event })"
        [attr.aria-expanded]="openActionMenuKey === actionMenuRowKey(i)"
        aria-haspopup="menu"
        aria-label="Row actions"
      >
        <icon-horizontal-dots class="size-5 rotate-90" />
      </button>
      @if (openActionMenuKey === actionMenuRowKey(i)) {
      <div
        appActionMenuPanel
        class="min-w-[13rem] overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg dark:border-[#191e3a] dark:bg-[#0e1726]"
        role="menu"
        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
      >
        @if (view === 'active') {
          @if (P.ROLE_MANAGE_PERMISSIONS | hasPermission) {
          <button
            type="button"
            role="menuitem"
            class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium rounded-t-xl text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
            (click)="closeMenu.emit(); goToManagePermissions(row)"
          >
            <icon-settings class="size-4 shrink-0" />
            Manage Permission
          </button>
          }
          @if (P.ROLE_UPDATE | hasPermission) {
          <button
            type="button"
            role="menuitem"
            class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:text-white-dark dark:hover:bg-white/5"
            (click)="closeMenu.emit(); edit.emit(row)"
          >
            <icon-edit class="size-4 shrink-0" />
            Edit
          </button>
          }
          @if (P.ROLE_TOGGLE_STATUS | hasPermission) {
          <button
            type="button"
            role="menuitem"
            class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:border-[#191e3a] dark:text-white-dark dark:hover:bg-white/5"
            (click)="closeMenu.emit(); toggleStatus.emit(row)"
          >
            <icon-refresh class="size-4 shrink-0" />
            {{ row.is_active ? 'Deactivate' : 'Activate' }}
          </button>
          }
          @if (P.ROLE_DELETE | hasPermission) {
          <button
            type="button"
            role="menuitem"
            class="flex w-full items-center gap-3 border-t border-gray-100 px-3 py-2.5 text-left text-xs font-medium rounded-b-xl text-danger hover:bg-gray-50 dark:border-[#191e3a] dark:hover:bg-white/5"
            (click)="closeMenu.emit(); delete.emit(row)"
          >
            <icon-trash-lines class="size-4 shrink-0 text-danger" />
            Delete
          </button>
          }
        } @else {
          @if (P.ROLE_RESTORE | hasPermission) {
          <button
            type="button"
            role="menuitem"
            class="flex w-full items-center gap-3 px-3 py-2.5 text-left text-xs font-medium text-[#18214d] hover:bg-gray-50 dark:text-white-dark dark:hover:bg-white/5"
            [ngClass]="(P.ROLE_DELETE | hasPermission) ? '' : 'rounded-b-xl'"
            (click)="closeMenu.emit(); restore.emit(row)"
          >
            <icon-restore class="size-4 shrink-0 text-[#18214d] dark:text-white" />
            Restore
          </button>
          }
          @if (P.ROLE_DELETE | hasPermission) {
          <button
            type="button"
            role="menuitem"
            class="flex w-full items-center gap-3 rounded-b-xl px-3 py-2.5 text-left text-xs font-medium text-danger hover:bg-gray-50 dark:hover:bg-white/5"
            (click)="closeMenu.emit(); permanentDelete.emit(row)"
          >
            <icon-trash-lines class="size-4 shrink-0 text-danger" />
            Delete permanently
          </button>
          }
        }
      </div>
      }
    </div>
    }
  </ng-template>
</app-list-module-table>
